import $ from 'jquery';

export const showNavbarPrivateBackButton = () => {
  $('#navbar-private-button-back').show();
  $('.logo').hide();
};
